@if (isProgressBarVisible$ | async) {
<progress-bar class="progress-bar">
</progress-bar>
}

<div class="refresher">

    <div class="loading-bar">
    </div>
    <div class="loading-bar">
    </div>
    <div class="loading-bar">
    </div>
    <div class="loading-bar">
    </div>

</div>

@let configuration = configuration$ | async;
@let isHybrid = isHybrid$ | async;
@let isMobile = isMobile$ | async;
@let isShowSmartBanner = isShowSmartBanner$ | async;

<div scrollToTopTarget class="global" id="main" [class.global--toolbar]="!configuration.layout.toolbar.hidden"
    [class.global--smart]="isShowSmartBanner"
    [style.--main-desktop-img]="'url(/assets/images/decoration/landing/landing.webp)'"
    [style.--main-mobile-img]="'url(/assets/images/decoration/landing/landing-mobile.webp)'">

    @if (isShowSmartBanner) {
    <smart-banner class="global-smart" [isDarkMode]="isDarkMode">
    </smart-banner>
    }

    @if (!configuration.layout.toolbar.hidden && !isHybrid && !isMobile) {
    <toolbar class="global-toolbar">
    </toolbar>
    }

    <div class="global-content" [class.global-content--without-footer]="configuration.layout.footer.hidden && isHybrid"
        cdkScrollable scrollToTopContainer [scrollToTopOffset]="250">

        <!--
            @if ("true") hack is required here for router-outlet to work
            correctly. Otherwise, it won't register the changes on the
            layout and won't update the view.
        -->
        @if (true) {
        <router-outlet>
        </router-outlet>
        }

        <div class="global-content-print">
            View is not supported by the Printed Version
        </div>

        @if (!configuration.layout.footer.hidden && !isHybrid) {
        <footer class="global-footer">
        </footer>
        }

    </div>

    @if (isUserAuthorized) {
    <navigation-panel class="global-bottombar">
    </navigation-panel>
    }

    @if (!configuration.layout.spinner.hidden) {
    <custom-spinner class="rpc-spinner-wrap">
    </custom-spinner>
    }

</div>